import React from 'react'
import { keyframes } from '@emotion/react'
import { AppImages, variantProvider } from '@/app'
import { modal, ModalParams } from '@codeleap/modals'
import { Image, Text, View } from '@/components'
import { SuccessPersonaSelected } from './SuccessPersonaSelected'
import { APIClient, useSharedSettings } from '@/services'

const imageSize = 300

const pulse = keyframes({
  '0%': { transform: 'scale(1)' },
  '50%': { transform: 'scale(1.2)' },
  '100%': { transform: 'scale(1)' },
})

function Content(props: ModalParams) {
  const { toggle } = props

  const sharedSettings = useSharedSettings()

  React.useEffect(() => {
    const timer = setTimeout(() => {
      toggle()
      SuccessPersonaSelected.toggle()
    }, sharedSettings.settings.learn.personaLoadingTime || 6000)
    APIClient.Learn.groupsManager.queryKeys.refetchList()
    return () => clearTimeout(timer)
  }, [toggle, sharedSettings.settings.learn.personaLoadingTime])

  return (
    <View style={styles.wrapper}>
      <Text variants={['h1', 'color:neutral1']} text='Personalising your journey...' />

      <Image source={AppImages.pulseAnimation} css={styles.pulseImage} />

      <Text
        variants={['h2', 'color:neutral1', 'textCenter', 'marginHorizontal:2']}
        text="Don't worry, this only takes a few seconds!"
      />
    </View>
  )
}

const styles = variantProvider.createComponentStyle(
  t => ({
    wrapper: {
      ...t.presets.fullWidth,
      ...t.presets.column,
      ...t.presets.center,
      height: 700,
      backgroundImage: `url(${AppImages.appBlueBg})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      ...t.spacing.padding(3),
      ...t.spacing.gap(3),
    },
    pulseImage: {
      height: imageSize,
      width: 'auto',
      maxWidth: '100%',
      objectFit: 'contain',
      animation: `${pulse} 1600ms ease-in-out infinite`,
      transformOrigin: 'center',
      display: 'block',
    },
  }),
  true,
)

export const OnboardingSuccessModal = modal()
  .content(props => <Content {...props} />)
  .props({
    variants: ['noPadding', 'centered', 'width:700'],
    closable: false,
  })
